// src/features/landing/domain/recruitmentOptions.js
// 설계사 채용관 "보험설계사 채용등록"(applicantType = AGENCY_PLANNER) 폼/상세에서 공유하는 선택지 상수.
// 저장은 code 문자열(배열)로 하고 화면에서는 label로 매핑한다 — label을 바꿔도 데이터가 안 깨진다.

export const RECRUIT_REGIONS = [
    { code: "NATIONWIDE", label: "전국" },
    { code: "SEOUL", label: "서울" },
    { code: "BUSAN", label: "부산" },
    { code: "DAEGU", label: "대구" },
    { code: "INCHEON", label: "인천" },
    { code: "GWANGJU", label: "광주" },
    { code: "DAEJEON", label: "대전" },
    { code: "ULSAN", label: "울산" },
    { code: "SEJONG", label: "세종" },
    { code: "GYEONGGI", label: "경기" },
    { code: "GANGWON", label: "강원" },
    { code: "CHUNGBUK", label: "충북" },
    { code: "CHUNGNAM", label: "충남" },
    { code: "JEONBUK", label: "전북" },
    { code: "JEONNAM", label: "전남" },
    { code: "GYEONGBUK", label: "경북" },
    { code: "GYEONGNAM", label: "경남" },
    { code: "JEJU", label: "제주" },
];

export const STRONG_SALES_AREAS = [
    { code: "DB_SALES", label: "DB 영업" },
    { code: "CORP_SALES", label: "법인 영업" },
    { code: "ONLINE_SALES", label: "온라인 영업" },
    { code: "PIONEER_SALES", label: "개척 영업" },
    { code: "REFERRAL_SALES", label: "소개·지인 영업" },
    { code: "TM_SALES", label: "TM(전화) 영업" },
    { code: "EVENT_SALES", label: "행사 영업" },
    { code: "EXPO_SALES", label: "박람회 영업" },
    { code: "BRIEFING_SALES", label: "브리핑 영업" },
    { code: "BANCASSURANCE", label: "방카슈랑스" },
    { code: "GROUP_WELFARE_SALES", label: "단체·복지 영업" },
    { code: "RETIREMENT_PENSION", label: "퇴직연금·기업복지" },
    { code: "ETC", label: "기타" },
];

export const WORK_TYPES = [
    { code: "FULL_TIME", label: "전업" },
    { code: "SIDE_JOB_OK", label: "겸업가능" },
    { code: "FREE_REMOTE", label: "자유(재택)" },
];

export const EMPLOYMENT_TYPES = [
    { code: "COMMISSION", label: "위촉직" },
    { code: "CONTRACT", label: "계약직" },
    { code: "REGULAR", label: "정규직" },
];

export const SUPPORT_ITEMS = [
    { code: "DB_PROVISION", label: "DB 제공" },
    { code: "OFFICE", label: "사무실 제공" },
    { code: "ADMIN_SUPPORT", label: "총무·행정 지원" },
    { code: "EDU_COACHING", label: "교육·코칭" },
    { code: "IT_SYSTEM", label: "전산·시스템" },
    { code: "ETC", label: "기타" },
];

const toLabel = (list) => (code) => (list.find((o) => o.code === code) || {}).label || code;

export const regionLabel = toLabel(RECRUIT_REGIONS);
export const strongSalesAreaLabel = toLabel(STRONG_SALES_AREAS);
export const workTypeLabel = toLabel(WORK_TYPES);
export const employmentTypeLabel = toLabel(EMPLOYMENT_TYPES);
export const supportItemLabel = toLabel(SUPPORT_ITEMS);
